import { supabase } from "@/integrations/supabase/client";

export interface ClosureImpactedReservation {
  id: string;
  date: string;
  startTime: string;
  numberOfPeople: number;
  customerName: string;
  status: string;
}

export interface ClosureImpact {
  hasImpact: boolean;
  impactedCount: number;
  impactedReservations: ClosureImpactedReservation[];
}

/**
 * Vérifie l'impact d'une période de fermeture sur les réservations existantes
 * Retourne la liste des réservations qui tombent pendant la période proposée
 */
export async function checkClosureImpact(
  startDate: string,
  endDate: string,
  establishmentId: string,
  excludeClosureId?: string
): Promise<ClosureImpact> {
  const { data: reservations, error } = await supabase
    .from('reservations')
    .select(`
      id, date, start_time, number_of_people, status,
      customers (first_name, last_name)
    `)
    .eq('establishment_id', establishmentId)
    .gte('date', startDate)
    .lte('date', endDate)
    .neq('status', 'annulé')
    .order('date')
    .order('start_time');

  if (error) {
    console.error('Erreur vérification impact fermeture:', error);
    throw error;
  }

  const impactedReservations = (reservations || []).map(r => ({
    id: r.id,
    date: r.date,
    startTime: r.start_time,
    numberOfPeople: r.number_of_people,
    customerName: r.customers 
      ? [r.customers.first_name, r.customers.last_name].filter(Boolean).join(' ') || 'Client inconnu'
      : 'Client inconnu',
    status: r.status
  }));

  return {
    hasImpact: impactedReservations.length > 0,
    impactedCount: impactedReservations.length,
    impactedReservations
  };
}
